import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    piIconOpenNewWindow,
    piIconReferenceProfileAdapter,
    piIconReferenceProfileAltruist,
    piIconReferenceProfileAnalyzer,
    piIconReferenceProfileArtisan,
    piIconReferenceProfileCaptain,
    piIconReferenceProfileCollaborator,
    piIconReferenceProfileController,
    piIconReferenceProfileCraftsman,
    piIconReferenceProfileGuardian,
    piIconReferenceProfileIndividualist,
    piIconReferenceProfileMaverick,
    piIconReferenceProfileOperator,
    piIconReferenceProfilePersuader,
    piIconReferenceProfilePromoter,
    piIconReferenceProfileScholar,
    piIconReferenceProfileSpecialist,
    piIconReferenceProfileStrategist,
    piIconReferenceProfileVenturer
} from '@predictiveindex/pi-client-icons';
import {
    TapestryButtonModule,
    TapestryIconModule,
    TapestrySpinnerModule
} from '@predictiveindex/tapestry';
import { TapestryIconRegistryService } from '@predictiveindex/tapestry';
import { PatternInsightsModule } from '../../../pattern-insights';
import { TranslationsModule } from '../../../translations';
import { GlobalSearchInspireCtaModule } from '../global-search-inspire-cta/global-search-inspire-cta.module';
import { GlobalSearchPersonSnapshotComponent } from './global-search-person-snapshot.component';

@NgModule({
    declarations: [GlobalSearchPersonSnapshotComponent],
    imports: [
        CommonModule,
        TapestryIconModule,
        PatternInsightsModule,
        TranslationsModule,
        TapestryButtonModule,
        GlobalSearchInspireCtaModule,
        TapestrySpinnerModule
    ],
    exports: [GlobalSearchPersonSnapshotComponent]
})
export class GlobalSearchPersonSnapshotModule {
    constructor(private iconRegistryService: TapestryIconRegistryService) {
        iconRegistryService.registerIcons([
            piIconReferenceProfileAdapter,
            piIconReferenceProfileAltruist,
            piIconReferenceProfileAnalyzer,
            piIconReferenceProfileArtisan,
            piIconReferenceProfileCaptain,
            piIconReferenceProfileCollaborator,
            piIconReferenceProfileController,
            piIconReferenceProfileCraftsman,
            piIconReferenceProfileGuardian,
            piIconReferenceProfileIndividualist,
            piIconReferenceProfileMaverick,
            piIconReferenceProfileOperator,
            piIconReferenceProfilePersuader,
            piIconReferenceProfilePromoter,
            piIconReferenceProfileScholar,
            piIconReferenceProfileSpecialist,
            piIconReferenceProfileStrategist,
            piIconReferenceProfileVenturer,
            piIconOpenNewWindow
        ]);
    }
}
